import { render, staticRenderFns } from "./JdsPanelGridLayout.vue?vue&type=template&id=6f8b634a&scoped=true&"
import script from "./JdsPanelGridLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsPanelGridLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b634a",
  null
  
)

export default component.exports